import { Injectable } from '@angular/core';
import { rethrowAsSapError } from 'src/app/lego-utils';
import { map } from 'rxjs/operators';
import { PMOrderAdapter } from 'src/app/models/domain/adapters';
import { HeaderSetService, YPMORDERSRVHeader } from 'src/generated-clients/order';

@Injectable({
  providedIn: 'root',
})
export class PMOrderDataService {
  public constructor(
    private readonly headerSetService: HeaderSetService,
    private readonly pmOrderAdapter: PMOrderAdapter
  ) {}

  public getByEquipmentNumber(equipmentNumber: string) {
    const equipmentNumberPropertyName: keyof YPMORDERSRVHeader = 'equipmentNumber';

    return this.headerSetService
      .headerSetGet(
        undefined,
        undefined,
        `${equipmentNumberPropertyName} eq '${equipmentNumber}' and startswith(orderType, 'ZML')`
      )
      .pipe(
        rethrowAsSapError(),
        map((res) => {
          if (!res.d?.results) {
            throw new Error('SAP Error');
          }

          return res.d.results.map((result) => this.pmOrderAdapter.adaptToDomain(result));
        })
      );
  }
}
